import React from 'react';
import { NavLink as RRDLink, type LinkProps } from 'react-router-dom';
import { useHandleLinkClick } from './useHandleLinkClick';

export const NavLink: React.FC<LinkProps> = ({
    to, onClick, target, ...restProps
}) => {
    const handleClick = useHandleLinkClick({ to, onClick, target });

    return (
        <RRDLink
            to={to}
            onClick={handleClick}
            target={target}
            {...restProps}
        />
    );
};